export default {
  filteredReports(state) {
    return state.reports.filter((report) => {
      const checkWithReportTitle = report.title.toLowerCase()
        .indexOf(state.reportName.toLowerCase()) > -1;

      return !state.reportName || checkWithReportTitle;
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/bi-reports/store/getters.js